import { getQueryParameters } from '@sixfold/app-utils';
import { SpinnerOverlay } from '@sixfold/common-ui';
import { isNil } from '@sixfold/typed-primitives';
import * as React from 'react';
import { Navigate, useLocation } from 'react-router';

import { BackendError } from '../../../shared/types/error';
import { ErrorView } from '../../components/error_view';
import { SharedView, SharedViewPicker } from '../../components/shared_view_picker';
import { buildUrl } from '../../lib/build_url';
import * as Routes from '../../lib/routes';
import { useTokenData } from '../../lib/token';
import { navigateToLocationWithServerSideRendering } from '../../lib/util';

interface SharedViewAccessLoginToken {
  resourceType: 'SHARED_VIEW_ACCESS_LOGIN';
  sharedViews: SharedView[];
}

export const SharedViewLoginContainer: React.FC = () => {
  const { token, next } = getQueryParameters(useLocation().search);
  const { data, isLoading } = useTokenData<SharedViewAccessLoginToken>(token);

  if (isNil(token)) {
    return <Navigate to={`${Routes.LandingPage.routerPath}?error=MISSING_TOKEN`} replace />;
  }

  if (isLoading) {
    return <SpinnerOverlay />;
  }

  if (isNil(data)) {
    return <ErrorView error={{ type: BackendError.SHARED_VIEW }} />;
  }

  return (
    <SharedViewPicker
      sharedViews={data.sharedViews}
      onNavigate={(sharedViewId?: string) => {
        navigateToLocationWithServerSideRendering(
          buildUrl(Routes.SharedViewLoginToken.generatePath({ token }), [
            { key: 'shared_view_id', value: sharedViewId },
            { key: 'next', value: next },
          ]),
        );
      }}
    />
  );
};
